import React from 'react'
import { STEP_TYPE_ENUM, TASK_TYPE_ENUM } from 'services/api/constants'
import { useNewTranslation } from 'hooks'
import { BaseEditorContainer, EditorContentCardContainer } from '../../styles'
import styled from 'particles/themes/styled'
import Field from 'components/Shared/Fields'
import BaseDivider from '../../BaseDivider'
import ExtraTextEditor from '../../ExtraTextEditor'
import { Title } from '../../../Shared'
import CampaignEditorInputFieldContainer from 'components/Shared/Permission/CampaignEditorInputFieldContainer'

interface SubmitUrlEditorProps {
    type: TASK_TYPE_ENUM
    stepType: STEP_TYPE_ENUM
    stepNumber: number
    requiredFieldNames: string[]
    uuid: string
    className?: string
    isReadOnly?: boolean
}

const SubmitUrlEditor: React.FC<SubmitUrlEditorProps> = ({
    type,
    stepType,
    stepNumber,
    requiredFieldNames,
    uuid,
    className,
    isReadOnly,
}) => {
    const [t] = useNewTranslation()
    const taskTypeNameWithoutVersion = type.split(/(_v\d+)/)[0] as TASK_TYPE_ENUM

    return (
        <BaseEditorContainer className={className} id={uuid && uuid}>
            <EditorContentCardContainer>
                <Title taskType={taskTypeNameWithoutVersion} stepType={stepType} stepNumber={stepNumber} />
                <CampaignEditorInputFieldContainer>
                    <Field.TextInputField
                        className={'input-area'}
                        label={t('campaignEditor.createTask.enterStepTitleHeader')}
                        name={`stepData.${stepType}.data.title`}
                        isRequired={requiredFieldNames.includes('title')}
                        width={'100%'}
                        isReadOnly={isReadOnly}
                    />
                </CampaignEditorInputFieldContainer>
                <BaseDivider />

                {!isReadOnly && (
                    <CampaignEditorInputFieldContainer>
                        <ExtraTextEditor name={`stepData.${stepType}.data.extra_data`} isRequired />
                    </CampaignEditorInputFieldContainer>
                )}
            </EditorContentCardContainer>
        </BaseEditorContainer>
    )
}
export default styled(SubmitUrlEditor)`
    padding-bottom: 80px;
`
